<template>
  <div>
    <div class="flex-between-center">
      <!-- 头图 -->
      <img
        class="img"
        v-if="showImg && $$(courseInfo.pic_url[0])"
        :src="$$(courseInfo.pic_url[0])"
        alt=""
      />
      <div
        :class="[
          'column-between-center',
          showImg && $$(courseInfo.pic_url[0]) ? 'info-right' : 'info-full',
        ]"
      >
        <!-- 学科 名称 -->
        <div class="name-wrap">
          <div class="inner-name">
            <p
              class="position-inner-tag"
              v-if="$$(course.extra_info.subject_name)"
            >
              {{ $$(course.extra_info.subject_name) }}
            </p>
            {{ courseInfo.name }}
          </div>
          <!-- 上课时间 -->
          <div
            class="desc"
            v-if="
              (courseInfo.product_type === 100 ||
                courseInfo.product_type === 300) &&
              $$(course.desc)
            "
          >
            {{ $$(course.desc) }}
          </div>
        </div>
        <div class="card-bottom">
          <!-- 卖点 -->
          <div
            class="highlight"
            v-if="courseInfo.selling_point && showSellingPoint"
          >
            {{ courseInfo.selling_point }}
          </div>
          <div v-else></div>
          <!-- 价格 -->
          <div class="price">
            <div class="flex-end-baseline">
              <span class="char">¥</span>
              <span>{{ buyPrice }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    courseInfo: {
      type: Object,
      default: () => ({}),
    },
    price: {
      type: Object,
      default: () => {
        return {};
      },
    },
    selectType: {
      type: Number,
    },
  },
  computed: {
    ...mapState({
      stateContCourseData: (state) => state.contCourseData,
    }),
    // 有的有图，有的没图，就会信息错位显示，阅读识别性大大降低
    // 存在没图的商品，则统一不显示图片
    showImg() {
      const { recom_list = [] } = this.stateContCourseData || {};
      const products = [];
      recom_list
        .filter((item) => item.isAddPriceBuy)
        .forEach((item) => {
          products.push(...item.package_info);
        });
      return products.filter((item) => item.pic_url.length === 0).length === 0;
    },
    course() {
      // 获取课程信息
      return (
        this.courseInfo?.product_list?.find((item) => item.type === 100) || {
          extra_info: {},
        }
      );
    },
    showSellingPoint() {
      // course_struct_id 1 是系统课，不展示卖点
      return this.course?.extra_info?.course_struct_id !== "1";
    },
    salePrice() {
      return this.price?.sale_price; //后端取值逻辑：销售期价格 || 课程原价
    },
    buyPrice() {
      const { selectType, price } = this;
      const { buy_price } = price || {}; // 加价接口返回的价格
      // 商品勾选的情况下使用计价接口返回的价格
      if (+selectType === 2 && (!!buy_price || buy_price === 0)) {
        return buy_price;
      }
      return this.salePrice;
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../assets/less/layout.less";
.img {
  width: 86px;
  height: 86px;
  margin-right: 8px;
  border-radius: 12px;
  object-fit: cover;
  flex-shrink: 0;
}
.info-right {
  min-height: 86px;
  width: calc(100% - 94px);
  .name-wrap {
    width: 100%;
  }
}
.inner-tag {
  display: inline-block;
  white-space: nowrap;
  padding: 0 3px;
  border-radius: 4px;
  height: 16px;
  margin-right: 4px;
  background-color: #e4a970;
  color: #fff;
  font-family: PingFang SC;
  font-size: 11px;
  font-weight: 500;
  line-height: 17px;
}
.position-inner-tag {
  .inner-tag;
  margin-right: 0;
  position: relative;
  top: -1px;
}
.inner-name {
  .ellipsis-two;
  color: #333;
  font-family: "PingFang SC";
  font-size: 15px;
  font-weight: 500;
  white-space: normal;
  word-break: break-all;
}
.desc {
  .ellipsis-one;
  margin-top: 4px;
  color: #666;
  font-family: "PingFang SC";
  font-size: 13px;
  letter-spacing: -0.5px;
}
.info-full {
  width: 100%;
  .card-bottom {
    margin-top: 5px;
    width: 100%;
  }
  .name-wrap {
    width: 100%;
  }
}
.card-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.highlight {
  .ellipsis-one;
  margin-right: 8px;
  flex: 1;
  color: #ff8e00;
  font-family: "PingFang SC";
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
}
.price {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  .char {
    margin-right: 2px;
    color: #f93834;
    text-align: right;
    font-size: 13px;
    font-weight: 500;
  }
  color: #f93834;
  font-family: DIN-Bold-700;
  font-size: 19px;
}
</style>
